import { withStyles } from '@mui/styles';

import AddCounterpartyForm from './AddCounterpartyForm';
import muiStyles from './styles';

export default withStyles(muiStyles)(AddCounterpartyForm as any);